import { render, staticRenderFns } from "./HLoader.vue?vue&type=template&id=6fa135b5&scoped=true&"
import script from "./HLoader.vue?vue&type=script&lang=js&"
export * from "./HLoader.vue?vue&type=script&lang=js&"
import style0 from "./HLoader.vue?vue&type=style&index=0&id=6fa135b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa135b5",
  null
  
)

export default component.exports